import React from "react";
import PropTypes from "prop-types";
import { FieldText } from "@conserveit/blocks";

const ResponsibleGroupForm = ({ groupName, onChange }) => (
  <FieldText
    className="group-name"
    name="group_name"
    label="Group Name"
    placeholder="Group Name"
    help="Warning: Group Name must match a Responsibility Role defined in Jira"
    onChange={onChange}
    value={groupName}
  />
);

ResponsibleGroupForm.propTypes = {
  groupName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

ResponsibleGroupForm.defaultProps = {
  groupName: "",
};

export default ResponsibleGroupForm;
